import {Directive, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {FormService} from "../../services/form.service";
import {debounceTime, takeWhile} from "rxjs/operators";
import {StandardName} from "../../../store/state/order.state";

@Directive({
    selector: '[scrollToFailedValidation]',
    standalone: false
})
export class ScrollToFailedValidationDirective implements OnInit, OnDestroy {

	private alive: boolean;

	constructor(private elementRef: ElementRef) {
	}

	ngOnInit(): void {
		this.alive = true;
	}

	initialize(formServices: FormService[]) {
		formServices.map(fs => fs.onSubmitClicked$()).forEach(formSubmitted$ => {
			formSubmitted$.pipe(takeWhile(() => this.alive), debounceTime(1000)).subscribe(() => {
				let invalidControls = formServices.map(fs => fs.getFirstInvalidControl()).filter(control => control != null);
				const firstInvalidControl = invalidControls.length > 0 ? this.getFirstInvalidControlConsideringStandards(invalidControls) : null;
				firstInvalidControl && this.navigateTo(firstInvalidControl);
			})
		});
	}

	ngOnDestroy(): void {
		this.alive = false;
	}

	private navigateTo(controlName: string) {
		let element = this.elementRef.nativeElement.querySelector(`[formControlName=${controlName}]`);
		if (element.style.display == 'none') {
			element.parentElement.scrollIntoView({behavior: "smooth", block: "center"});
		} else {
			element.scrollIntoView({behavior: "smooth", block: "center"});
		}
	}

	private getFirstInvalidControlConsideringStandards(invalidControls: string[]) {
		if (invalidControls.length == 1) {
			return invalidControls[0];
		}


		let standards = Object.getOwnPropertyNames(StandardName)
		invalidControls = invalidControls.sort((c1, c2) => {
			let standardIndexForControl1 = standards.indexOf(standards.find(s => c1.endsWith(s)));
			let standardIndexForControl2 = standards.indexOf(standards.find(s => c2.endsWith(s)));

			if (standardIndexForControl1 == -1 || standardIndexForControl2 == -1) {
				return 0;
			}

			return standardIndexForControl1 < standardIndexForControl2 ?
				-1 :
				(standardIndexForControl1 == standardIndexForControl2 ? 0 : 1);
		});

		return invalidControls[0];
	}
}
